import React from "react";
import iconoApple from "./images/1_home/apple.png";
import iconoGoogle from "./images/1_home/google-play-badge.png";
import { TITLE_FONT_SIZE, TEXT_FONT_SIZE } from "./const.js";

const Academy = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        color: "black",
        paddingLeft: 10,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          color: "black",
          paddingLeft: 10,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            fontFamily: "OswaldBoldItalic",
            flex: 1,
            textAlign: "center",
            marginBottom: 10,
            fontSize: TITLE_FONT_SIZE,
          }}
        >
          WHAT ARE YOU WAITING FOR,
          <br />
          DOWNLOAD NOW!
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <a href={"https://apps.apple.com/us/app/storm-bowling/id1494132195"}>
          <img
            style={{ flex: 1, maxWidth: "95%" }}
            src={iconoApple}
            alt={"apple"}
          />
        </a>
        <a
          href={
            "https://play.google.com/store/apps/details?id=ca.helmac.stormbowling"
          }
        >
          <img
            style={{ flex: 1, maxWidth: "95%" }}
            src={iconoGoogle}
            alt={"google"}
          />
        </a>
      </div>
    </div>
  );
};

export default Academy;
